import React from 'react';
import { motion } from 'framer-motion';

export default function FinalCTA() {
  return (
    <section className="py-32 bg-white relative overflow-hidden">
      <div className="absolute inset-0 bg-slate-50 opacity-50" />
      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-6xl font-bold text-slate-900 mb-6 tracking-tight">
            Don't miss a single moment.
          </h2>
          <p className="text-xl text-slate-600 mb-10 font-light max-w-2xl mx-auto">
            Start collecting memories from every guest today. Set up takes less than two minutes.
          </p>
          <button className="bg-slate-900 text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-slate-800 transition-all shadow-xl shadow-slate-900/20 active:scale-95">
            Create Your Event Now
          </button>
          <p className="mt-6 text-sm text-slate-500 font-medium">Free to start • No credit card required</p>
        </motion.div>
      </div>
    </section>
  );
}